import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Fallback = () => (
  <Box sx={{ p: 3 }}>
    <CircularProgress />
  </Box>
);
export default Fallback;
